import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { GridContainer, GridRow, GridColumn, Img } from "arv-reactcomponents";

import { Endpoints } from "npmlinks-constants";

import Analytics from "../../../../analytics";
import Event from "../../../../analytics/eventFactory";

import NavContainer from "../NavContainer";
import {
  LoginActionButton,
  GetAppActionButton,
  MyBagActionButton,
  SearchActionButton,
  StoreLocatorActionButton,
} from "../../ActionButtons";

@inject("HeaderStore", "NavListStore", "CommonStore")
@observer
class MainBar extends Component {
  static onLogoClick() {
    Analytics.trackEvent({
      action: Event.action.LOGO_CLICK,
      label: Event.label.getSource(window.pageType),
      category: Event.category.TOP_MENU_NAVIGATION,
    });
  }

  get isFixedClassName() {
    return (this.props.HeaderStore.isFixed && "is-fixed") || "";
  }

  get logoAlt() {
    const { brandName } = this.props.CommonStore;

    return brandName ? `${brandName} Logo` : "NNNOW image";
  }

  get logoImg() {
    const { navListData } = this.props.NavListStore;
    const logoFromApi =
      (navListData &&
        navListData.data &&
        navListData.data.logos &&
        navListData.data.logos.brand &&
        navListData.data.logos.brand.image) ||
      null;
    const logoUrl = logoFromApi || Endpoints.nnnowLogoUrl;

    if (logoUrl) {
      return (
        <Img
          className={`nw-mainbar-logo ${this.isFixedClassName}`}
          src={logoUrl}
          alt={this.logoAlt}
        />
      );
    }
    return null;
  }

  render() {
    return (
      <GridContainer
        className={`nw-mainbar-container ${this.isFixedClassName}`}
      >
        <GridRow className="nw-mainbar-row">
          <GridColumn className="nw-mainbar-col">
            <GridRow className={`nw-mainbar-nav-row ${this.isFixedClassName}`}>
              <GridColumn
                className={`
                  nwc-grid-col-sm
                  nw-mainbar-logo-container
                  ${this.isFixedClassName}
                `}
              >
                <a
                  href="/"
                  target="_self"
                  className="nw-mainbar-logo-link"
                  onClick={MainBar.onLogoClick}
                >
                  {this.logoImg}
                </a>
              </GridColumn>
              <GridColumn
                className={`
                  nwc-grid-col-sm
                  nw-mainbar-navactions-col
                  ${this.isFixedClassName}
                `}
              >
                <GridRow className="nw-mainbar-navactions-row">
                  <GridColumn className="nwc-grid-col-sm nwc-custom-scrollbar nw-mainbar-nav-col">
                    <NavContainer.component />
                  </GridColumn>
                  <GridColumn className="nwc-grid-col-sm nw-mainbar-actionbuttons">
                    <SearchActionButton.component
                      className={`
                        nw-mainbar-actionbutton
                        nw-mainbar-actionbutton-search
                        ${this.isFixedClassName}
                      `}
                    />
                    <GetAppActionButton.component
                      className="nw-mainbar-actionbutton"
                      logoClass={`
                        nw-mainbar-actionbutton-getapp
                        ${this.isFixedClassName}
                      `}
                    />
                    <StoreLocatorActionButton.component
                      className={`
                        nw-mainbar-actionbutton
                        nw-mainbar-actionbutton-storelocator
                        ${this.isFixedClassName}
                      `}
                    />
                    <LoginActionButton.component
                      className={`
                        nw-mainbar-actionbutton
                        nw-mainbar-actionbutton-login
                        ${this.isFixedClassName}
                      `}
                    />
                    <MyBagActionButton.component
                      className={`
                        nw-mainbar-actionbutton
                        nw-mainbar-actionbutton-mybag
                        ${this.isFixedClassName}
                      `}
                    />
                  </GridColumn>
                </GridRow>
              </GridColumn>
            </GridRow>
          </GridColumn>
        </GridRow>
      </GridContainer>
    );
  }
}

MainBar.wrappedComponent.propTypes = {
  NavListStore: PropTypes.shape({
    navListData: PropTypes.object,
  }).isRequired,
  HeaderStore: PropTypes.shape({
    isFixed: PropTypes.bool.isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    brandName: PropTypes.string.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("HeaderStore", "NavListStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: MainBar.wrappedComponent,
  component: MainBar,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Header/DesktopHeader/MainBar/index.js